
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      vxCollectionTitle: 'search/getCollectionTitle',
      vxPageDescription: 'search/getPageDescription',
    }),
  },
}
